import styled from 'styled-components';
import { FontWeight } from '../../../styled/constants';

export const GoogleMapContainer = styled.div`
  border-radius: 12px;
  overflow: hidden;
  overscroll-behavior: contain;
`;

export const BlueDot = styled.div`
  width: 10px;
  height: 10px;
  background: ${({ theme }) => theme.colors.systemColors.blue};
  border-radius: 50%;
  position: relative;
  z-index: 10;
`;

export const LogoWrapper = styled.div<{
  $active: boolean;
  $stackIndex?: number;
}>`
  position: absolute;
  ${({ $stackIndex }) =>
    $stackIndex === 1 ? `top: calc(100% + 24px);` : `bottom: calc(100% + 8px);`}
  left: 0;
  transform: ${({ $active }) =>
    $active ? 'translateX(-50px)' : 'translateX(-30px)'};
  z-index: ${({ $active }) => ($active ? 12 : 11)};
  width: ${({ $active }) => ($active ? '320px' : '68px')};
  height: ${({ $active }) => ($active ? 'auto' : '68px')};
  pointer-events: auto;
  cursor: pointer;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const InnerWrapper = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.systemColors.blue};
  border-radius: ${({ $active }) => ($active ? '17px' : '8px')};
  width: ${({ $active }) => ($active ? '320px' : '68px')};
  height: ${({ $active }) => ($active ? 'auto' : '68px')};
  padding: 0;
  transition:
    width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    border-radius 0.25s;
  overflow: hidden;
`;

export const LogoImgWrapper = styled.div<{ $active?: boolean }>`
  background: ${({ $active, theme }) =>
    $active ? theme.colors.systemColors.blue : 'transparent'};
  padding: ${({ $active }) => ($active ? '5px' : '0')};
  box-sizing: border-box;
  transition:
    background 0.2s,
    padding 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoImg = styled.img<{ $active?: boolean }>`
  width: ${({ $active }) => ($active ? '94px' : '68px')};
  height: ${({ $active }) => ($active ? '94px' : '68px')};
  border-radius: ${({ $active }) => ($active ? '17px' : '8px')};
  border: 2px solid ${({ theme }) => theme.colors.systemColors.blue};
  background: ${({ theme }) => theme.colors.systemColors.blue};
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 12px;
  transition:
    width 0.25s,
    height 0.25s,
    transform 0.2s,
    margin 0.2s;
  transform: scale(${({ $active }) => ($active ? 1.12 : 1)});
`;

export const LogoTextBlock = styled.div<{ $active: boolean }>`
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  pointer-events: ${({ $active }) => ($active ? 'auto' : 'none')};
  transition: opacity 0.2s;
  min-width: 0;
  width: 100%;
  strong {
    font-size: 15px;
    font-weight: ${FontWeight.medium};
    color: ${({ theme }) => theme.colors.text.white};
    margin-bottom: 2px;
    text-align: left;
    display: block;
    width: 95%;
  }
  p {
    font-size: 13px;
    font-weight: ${FontWeight.thin};
    margin: 0 0 15px 0;
    color: ${({ theme }) => theme.colors.text.white};
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const LogoButton = styled.a`
  margin-top: 0;
  display: inline-block;
  width: auto;
  min-width: 0;
  max-width: 100%;
  background: ${({ theme }) => theme.colors.text.white};
  color: ${({ theme }) => theme.colors.systemColors.cocoaBrown};
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 13px;
  font-weight: ${FontWeight.medium};
  text-decoration: none;
  border: 1px solid ${({ theme }) => theme.colors.text.white};
  transition:
    background 0.2s,
    color 0.2s;
`;

export const HiddenZeroDiv = styled.div`
  width: 0;
  height: 0;
  overflow: hidden;
`;

export const RelativeOneDiv = styled.div`
  position: relative;
  width: 1px;
  height: 1px;
`;
